"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PARTICIPANT_DELTAS = exports.PARTICIPANT = exports.ONLINE = exports.OFFLINE = exports.OFFER = exports.NETWORK_TYPE = exports.NETWORK_STATUS = exports.MediaContent = exports.MQA_STATS = exports.MQA_INTEVAL = exports.MODERATOR_TRUE = exports.MODERATOR_HINTS = exports.MODERATOR_FALSE = exports.METRICS_JOIN_TIMES_MAX_DURATION = exports.MEET_M = exports.MEETING_VIDEO_STATE_MACHINE = exports.MEETING_STATE_MACHINE = exports.MEETING_STATE = exports.MEETING_REMOVED_REASON = exports.MEETING_INFO_FAILURE_REASON = exports.MEETING_ERRORS = exports.MEETING_END_REASON = exports.MEETING_AUDIO_STATE_MACHINE = exports.MEETINGS = exports.MEETINGINFO = exports.MEET = exports.MEDIA_TRACK_CONSTRAINT = exports.MEDIA_STATE = exports.MEDIA_PEER_CONNECTION_NAME = exports.MEDIA_DEVICES = exports.MEDIA = exports.MAX_FRAMESIZES = exports.LOCUS_URL = exports.LOCUSINFO = exports.LOCUSEVENT = exports.LOCUS = exports.LOCI = exports.LOCAL = exports.LIVE = exports.LEAVE = exports.LAYOUT_TYPES = exports.JOIN_HINTS = exports.JOIN = exports.IPV4_REGEX = exports.INTENT_TO_JOIN = exports.ICE_TIMEOUT = exports.ICE_STATE = exports.ICE_GATHERING_STATE = exports.ICE_FAIL_TIMEOUT = exports.HTTP_VERBS = exports.HTTPS_PROTOCOL = exports.HOST = exports.HECATE = exports.GATHERING = exports.FULL_STATE = exports.FLOOR_ACTION = exports.EVENT_TYPES = exports.EVENT_TRIGGERS = exports.EVENT_STATS_MAP = exports.EVENTS = exports.ERROR_DICTIONARY = exports.ERROR = exports.ENDED = exports.DIALER_REGEX = exports.DEVELOPMENT = exports.DELTAEVENT = exports.DEFAULT_TRANSFORM_REGEX = exports.DEFAULT_TRANSFORM_KEYS = exports.DEFAULT_OMISSION_DATA_KEYS = exports.DEFAULT_GET_STATS_FILTER = exports.DEFAULT_FF_TRANSFORM_REGEX = exports.DEFAULT_EXCLUDED_STATS = exports.DEFAULT_EVENT_VIDEO_SEND_KEYS = exports.DEFAULT_EVENT_VIDEO_RECEIVE_KEYS = exports.DEFAULT_EVENT_AUDIO_SEND_KEYS = exports.DEFAULT_EVENT_AUDIO_RECEIVE_KEYS = exports.DECLINE = exports.CORRELATION_ID = exports.CONVERSATION_URL = exports.CONVERSATION_SERVICE = exports.CONTROLS = exports.CONTENT = exports.CONNECTION_STATE = exports.COMPLETE = exports.CMR_MEETINGS = exports.CLAIM = exports.CALL_REMOVED_REASON = exports.CALL = exports.CALENDAR_EVENTS_API = exports.CALENDAR_EVENTS = exports.CALENDAR = exports.AUDIO_STATUS = exports.AUDIO_INPUT = exports.AUDIO = exports.API = exports.ANSWER = exports.ANALYSIS_STATS = exports.ANALYSIS_CHECKS = exports.ALTERNATE_REDIRECT_TRUE = exports.ALERT = void 0;
exports._WEBEX_MEETING_ = exports._WAIT_ = exports._USER_ = exports._UNKNOWN_ = exports._S_LINE = exports._SLIDES_ = exports._SIP_URI_ = exports._SIP_BRIDGE_ = exports._SEND_RECEIVE_ = exports._SEND_ONLY_ = exports._ROOM_ = exports._RESOURCE_ROOM_ = exports._REQUESTED_ = exports._REMOVE_ = exports._RECEIVE_ONLY_ = exports._PERSONAL_ROOM_ = exports._PEOPLE_ = exports._OFFER_ = exports._OBSERVE_ = exports._NOT_IN_MEETING_ = exports._NONE_ = exports._MEETING_UUID_ = exports._MEETING_LINK_ = exports._MEETING_ID_ = exports._MEETING_CENTER_ = exports._MEETING_ = exports._LOCUS_ID_ = exports._LEFT_ = exports._JOIN_ = exports._JOINED_ = exports._IN_MEETING_ = exports._IN_LOBBY_ = exports._IN_ = exports._INCOMING_ = exports._INACTIVE_ = exports._ID_ = exports._IDLE_ = exports._FORCED_ = exports._ERROR_ = exports._CREATED_ = exports._CONVERSATION_URL_ = exports._CONFLICT_ = exports._CALL_ = exports._ANSWER_ = exports._ACTIVE_ = exports.WWW_DOT = exports.WHITEBOARD = exports.WEBEX_DOT_COM = exports.VIDEO_STATUS = exports.VIDEO_RESOLUTIONS = exports.VIDEO_INPUT = exports.VIDEO = exports.VALID_PMR_LINK = exports.VALID_PMR_ADDRESS = exports.VALID_PIN = exports.VALID_EMAIL_ADDRESS = exports.UUID_REG = exports.USE_URI_LOOKUP_FALSE = exports.TYPE = exports.STATS = exports.SIP_URI = exports.SHARE_STOPPED_REASON = exports.SHARE_STATUS = exports.SHARE_PEER_CONNECTION_NAME = exports.SHARE = exports.SEND_DTMF_ENDPOINT = exports.SENDRECV = exports.SDP = exports.RTC_CONFIGURATION_FIREFOX = exports.RTC_CONFIGURATION = exports.ROAP_SEQ_PRE = exports.ROAP = exports.RETRY_TIMEOUT = exports.RESOURCE = exports.REMOTE = exports.RECORDING_STATE = exports.RECONNECTION = exports.READY = exports.REACHABILITY = exports.QUALITY_LEVELS = exports.PSTN_STATUS = exports.PROVISIONAL_TYPE_DIAL_OUT = exports.PROVISIONAL_TYPE_DIAL_IN = exports.PEER_CONNECTION_STATE = exports.PC_BAIL_TIMEOUT = exports.PASSWORD_STATUS = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _common = require("@webex/common");

var _VIDEO_RESOLUTIONS, _MAX_FRAMESIZES;

// *********** LOWERCASE / CAMELCASE STRINGS ************
var AUDIO = 'audio';
exports.AUDIO = AUDIO;
var AUDIO_INPUT = 'audioinput';
exports.AUDIO_INPUT = AUDIO_INPUT;
var AUDIO_STATUS = 'audioStatus';
exports.AUDIO_STATUS = AUDIO_STATUS;
var ALERT = 'alert';
exports.ALERT = ALERT;
var ANSWER = 'answer';
exports.ANSWER = ANSWER;
var CALL = 'call';
exports.CALL = CALL;
var CORRELATION_ID = 'correlationId';
exports.CORRELATION_ID = CORRELATION_ID;
var CONVERSATION_URL = 'conversationUrl';
exports.CONVERSATION_URL = CONVERSATION_URL;
var CALENDAR = 'calendar';
exports.CALENDAR = CALENDAR;
var CALENDAR_EVENTS_API = 'calendarEvents';
exports.CALENDAR_EVENTS_API = CALENDAR_EVENTS_API;
var CMR_MEETINGS = 'cmrmeetings';
exports.CMR_MEETINGS = CMR_MEETINGS;
var CLAIM = 'claim';
exports.CLAIM = CLAIM;
var CONTROLS = 'controls';
exports.CONTROLS = CONTROLS;
var CONTENT = 'content';
exports.CONTENT = CONTENT;
var COMPLETE = 'complete';
exports.COMPLETE = COMPLETE;
var WHITEBOARD = 'whiteboard';
exports.WHITEBOARD = WHITEBOARD;
var GATHERING = 'gathering';
exports.GATHERING = GATHERING;
var DEVELOPMENT = 'development';
exports.DEVELOPMENT = DEVELOPMENT;
var DECLINE = 'decline';
exports.DECLINE = DECLINE;
var ERROR = 'error';
exports.ERROR = ERROR;
var ENDED = 'ended';
exports.ENDED = ENDED;
var OFFER = 'offer';
exports.OFFER = OFFER;
var HECATE = 'hecate';
exports.HECATE = HECATE;
var HOST = 'host';
exports.HOST = HOST;
var JOIN = 'join';
exports.JOIN = JOIN;
var LEAVE = 'leave';
exports.LEAVE = LEAVE;
var LIVE = 'live';
exports.LIVE = LIVE;
var LOCAL = 'local';
exports.LOCAL = LOCAL;
var LOCI = 'loci';
exports.LOCI = LOCI;
var LOCUS_URL = 'locusUrl';
exports.LOCUS_URL = LOCUS_URL;
var MEETINGINFO = 'meetingInfo';
exports.MEETINGINFO = MEETINGINFO;
var MEET = 'meet';
exports.MEET = MEET;
var MEET_M = 'm';
exports.MEET_M = MEET_M;
var MEDIA = 'media';
exports.MEDIA = MEDIA;
var OFFLINE = 'offline';
exports.OFFLINE = OFFLINE;
var ONLINE = 'online';
exports.ONLINE = ONLINE;
var PARTICIPANT = 'participant';
exports.PARTICIPANT = PARTICIPANT;
var PROVISIONAL_TYPE_DIAL_IN = 'DIAL_IN';
exports.PROVISIONAL_TYPE_DIAL_IN = PROVISIONAL_TYPE_DIAL_IN;
var PROVISIONAL_TYPE_DIAL_OUT = 'DIAL_OUT';
exports.PROVISIONAL_TYPE_DIAL_OUT = PROVISIONAL_TYPE_DIAL_OUT;
var REMOTE = 'remote';
exports.REMOTE = REMOTE;
var READY = 'ready';
exports.READY = READY;
var SEND_DTMF_ENDPOINT = 'sendDtmf';
exports.SEND_DTMF_ENDPOINT = SEND_DTMF_ENDPOINT;
var SENDRECV = 'sendrecv';
exports.SENDRECV = SENDRECV;
var SIP_URI = 'sipUri';
exports.SIP_URI = SIP_URI;
var SHARE = 'share';
exports.SHARE = SHARE;
var TYPE = 'type';
exports.TYPE = TYPE;
var VIDEO = 'video';
exports.VIDEO = VIDEO;
var VIDEO_INPUT = 'videoinput';
exports.VIDEO_INPUT = VIDEO_INPUT;
var VIDEO_STATUS = 'videoStatus'; // *********** UPPERCASE ONLY STRINGS ************
// Please alphabetize

exports.VIDEO_STATUS = VIDEO_STATUS;
var _ANSWER_ = 'ANSWER';
exports._ANSWER_ = _ANSWER_;
var _ACTIVE_ = 'ACTIVE';
exports._ACTIVE_ = _ACTIVE_;
var _CALL_ = 'CALL';
exports._CALL_ = _CALL_;
var _CREATED_ = 'CREATED';
exports._CREATED_ = _CREATED_;
var _CONFLICT_ = 'CONFLICT';
exports._CONFLICT_ = _CONFLICT_;
var _CONVERSATION_URL_ = 'CONVERSATION_URL';
exports._CONVERSATION_URL_ = _CONVERSATION_URL_;
var _ERROR_ = 'ERROR';
exports._ERROR_ = _ERROR_;
var _FORCED_ = 'FORCED';
exports._FORCED_ = _FORCED_;
var _IDLE_ = 'IDLE';
exports._IDLE_ = _IDLE_;
var _IN_LOBBY_ = 'IN_LOBBY';
exports._IN_LOBBY_ = _IN_LOBBY_;
var _IN_MEETING_ = 'IN_MEETING';
exports._IN_MEETING_ = _IN_MEETING_;
var _INCOMING_ = 'INCOMING';
exports._INCOMING_ = _INCOMING_;
var _IN_ = 'IN';
exports._IN_ = _IN_;
var _ID_ = 'id';
exports._ID_ = _ID_;
var _JOIN_ = 'JOIN';
exports._JOIN_ = _JOIN_;
var _JOINED_ = 'JOINED';
exports._JOINED_ = _JOINED_;
var _LOCUS_ID_ = 'LOCUS_ID';
exports._LOCUS_ID_ = _LOCUS_ID_;
var _LEFT_ = 'LEFT';
exports._LEFT_ = _LEFT_;
var _MEETING_LINK_ = 'MEETING_LINK';
exports._MEETING_LINK_ = _MEETING_LINK_;
var _MEETING_UUID_ = 'MEETING_UUID';
exports._MEETING_UUID_ = _MEETING_UUID_;
var _MEETING_ = 'MEETING';
exports._MEETING_ = _MEETING_;
var _MEETING_CENTER_ = 'MEETING_CENTER';
exports._MEETING_CENTER_ = _MEETING_CENTER_;
var _MEETING_ID_ = 'MEETING_ID';
exports._MEETING_ID_ = _MEETING_ID_;
var _NOT_IN_MEETING_ = 'NOT_IN_MEETING';
exports._NOT_IN_MEETING_ = _NOT_IN_MEETING_;
var _NONE_ = 'NONE';
exports._NONE_ = _NONE_;
var _OFFER_ = 'OFFER';
exports._OFFER_ = _OFFER_;
var _OBSERVE_ = 'OBSERVE';
exports._OBSERVE_ = _OBSERVE_;
var _PERSONAL_ROOM_ = 'PERSONAL_ROOM';
exports._PERSONAL_ROOM_ = _PERSONAL_ROOM_;
var _PEOPLE_ = _common.hydraTypes.PEOPLE;
exports._PEOPLE_ = _PEOPLE_;
var _REQUESTED_ = 'REQUESTED';
exports._REQUESTED_ = _REQUESTED_;
var _RESOURCE_ROOM_ = 'RESOURCE_ROOM';
exports._RESOURCE_ROOM_ = _RESOURCE_ROOM_;
var _RECEIVE_ONLY_ = 'RECVONLY';
exports._RECEIVE_ONLY_ = _RECEIVE_ONLY_;
var _REMOVE_ = 'REMOVE';
exports._REMOVE_ = _REMOVE_;
var _ROOM_ = _common.hydraTypes.ROOM;
exports._ROOM_ = _ROOM_;
var _SIP_BRIDGE_ = 'SIP_BRIDGE';
exports._SIP_BRIDGE_ = _SIP_BRIDGE_;
var _SIP_URI_ = 'SIP_URI';
exports._SIP_URI_ = _SIP_URI_;
var _SEND_RECEIVE_ = 'SENDRECV';
exports._SEND_RECEIVE_ = _SEND_RECEIVE_;
var _SEND_ONLY_ = 'SENDONLY';
exports._SEND_ONLY_ = _SEND_ONLY_;
var _INACTIVE_ = 'INACTIVE';
exports._INACTIVE_ = _INACTIVE_;
var _SLIDES_ = 'SLIDES';
exports._SLIDES_ = _SLIDES_;
var _S_LINE = 's=-';
exports._S_LINE = _S_LINE;
var _USER_ = 'USER';
exports._USER_ = _USER_;
var _UNKNOWN_ = 'UNKNOWN';
exports._UNKNOWN_ = _UNKNOWN_;
var _WEBEX_MEETING_ = 'WEBEX_MEETING';
exports._WEBEX_MEETING_ = _WEBEX_MEETING_;
var _WAIT_ = 'WAIT'; // *********** PARTICIPANT DELTAS ***********

exports._WAIT_ = _WAIT_;
var PARTICIPANT_DELTAS = {
  TARGETS: {
    AUDIO: 'audio',
    VIDEO: 'video'
  },
  STATES: {
    DISABLED: 'disabled',
    MUTED: 'muted',
    UNKNOWN: 'unknown',
    UNMUTED: 'unmuted'
  }
}; // *********** STRING HELPERS ***********
// Please alphabetize

exports.PARTICIPANT_DELTAS = PARTICIPANT_DELTAS;
var ALTERNATE_REDIRECT_TRUE = 'alternateRedirect=true';
exports.ALTERNATE_REDIRECT_TRUE = ALTERNATE_REDIRECT_TRUE;
var HTTPS_PROTOCOL = 'https://';
exports.HTTPS_PROTOCOL = HTTPS_PROTOCOL;
var MEETINGS = 'Meetings';
exports.MEETINGS = MEETINGS;
var MEDIA_PEER_CONNECTION_NAME = 'MediaPeerConnection';
exports.MEDIA_PEER_CONNECTION_NAME = MEDIA_PEER_CONNECTION_NAME;
var SHARE_PEER_CONNECTION_NAME = 'SharePeerConnection';
exports.SHARE_PEER_CONNECTION_NAME = SHARE_PEER_CONNECTION_NAME;
var USE_URI_LOOKUP_FALSE = 'useUriLookup=false';
exports.USE_URI_LOOKUP_FALSE = USE_URI_LOOKUP_FALSE;
var WWW_DOT = 'www.';
exports.WWW_DOT = WWW_DOT;
var WEBEX_DOT_COM = 'webex.com';
exports.WEBEX_DOT_COM = WEBEX_DOT_COM;
var CONVERSATION_SERVICE = 'identityLookup'; // ******************* ARRAYS ********************
// Please alphabetize

exports.CONVERSATION_SERVICE = CONVERSATION_SERVICE;
var DEFAULT_EXCLUDED_STATS = ['timestamp', 'ssrc', 'priority'];
/**
 * @description @description Layout type for remote video participants. Allowed values are: Single, Equal, ActivePresence, Prominent, OnePlusN
 * @type {array}
 * @constant
 */

exports.DEFAULT_EXCLUDED_STATS = DEFAULT_EXCLUDED_STATS;
var LAYOUT_TYPES = ['Single', 'Equal', 'ActivePresence', 'Prominent', 'OnePlusN']; // ******************* BOOLEANS *******************
// Please alphabetize

exports.LAYOUT_TYPES = LAYOUT_TYPES;
var MODERATOR_TRUE = true;
exports.MODERATOR_TRUE = MODERATOR_TRUE;
var MODERATOR_FALSE = false; // ******************** NUMBERS ********************

exports.MODERATOR_FALSE = MODERATOR_FALSE;
var INTENT_TO_JOIN = [2423005, 2423006, 2423016, 2423017, 2423018];
exports.INTENT_TO_JOIN = INTENT_TO_JOIN;
var ICE_TIMEOUT = 2000;
exports.ICE_TIMEOUT = ICE_TIMEOUT;
var ICE_FAIL_TIMEOUT = 3000;
exports.ICE_FAIL_TIMEOUT = ICE_FAIL_TIMEOUT;
var RETRY_TIMEOUT = 3000;
exports.RETRY_TIMEOUT = RETRY_TIMEOUT;
var ROAP_SEQ_PRE = -1;
exports.ROAP_SEQ_PRE = ROAP_SEQ_PRE;
var PC_BAIL_TIMEOUT = 8000; // ******************** REGEX **********************
// Please alphabetize

exports.PC_BAIL_TIMEOUT = PC_BAIL_TIMEOUT;
var DIALER_REGEX = {
  // modified from https://github.com/kirm/sip.js base
  // and with https://tools.ietf.org/html/rfc3261
  // requires the @ symbol
  SIP_ADDRESS: /^(sips?)?:?(?:([^\s>:@]+)(?::([^\s@>]+))?@)([\w\-.]+)(?::(\d+))?((?:;[^\s=?>;]+(?:=[^\s?;]+)?)*)(?:\?(([^\s&=>]+=[^\s&=>]+)(&[^\s&=>]+=[^\s&=>]+)*))?$/,
  // standard telephony num regex
  PHONE_NUMBER: /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/,
  E164_FORMAT: /^\+[1-9]\d{1,14}$/
}; // eslint-disable-next-line max-len

exports.DIALER_REGEX = DIALER_REGEX;
var IPV4_REGEX = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}|.local/g;
exports.IPV4_REGEX = IPV4_REGEX;
var DEFAULT_TRANSFORM_REGEX = {
  rtpOutVideo: {
    regex: new RegExp('^(?:RTC)?[Oo]utbound_?[Rr][Tt][Pp]_?[Vv]ideo')
  },
  rtpOutAudio: {
    regex: new RegExp('^(?:RTC)?[Oo]utbound_?[Rr][Tt][Pp]_?[Aa]udio')
  },
  rtpInVideo: {
    regex: new RegExp('^(?:RTC)?[Ii]nbound_?[Rr][Tt][Pp]_?[Vv]ideo')
  },
  rtpInAudio: {
    regex: new RegExp('^(?:RTC)?[Ii]nbound_?[Rr][Tt][Pp]_?[Aa]udio')
  },
  rtpRemoteInboundAudio: {
    regex: new RegExp('^(?:RTC)?[Rr]emote[Ii]nbound_?[Rr][Tt][Pp]_?[Aa]udio[sS]tream_?.*')
  },
  rtpRemoteOutboundAudio: {
    regex: new RegExp('^(?:RTC)?[Rr]emote[Oo]utbound_?[Rr][Tt][Pp]_?[Aa]udio[sS]tream_?.*')
  },
  rtpRemoteInboundVideo: {
    regex: new RegExp('^(?:RTC)?[Rr]emote[Ii]nbound_?[Rr][Tt][Pp]_?[Vv]ideo[sS]tream_?.*')
  },
  rtpRemoteOutboundVideo: {
    regex: new RegExp('^(?:RTC)?[Rr]emote[Oo]utbound_?[Rr][Tt][Pp]_?[Vv]ideo[sS]tream_?.*')
  },
  rtcOutAudio: {
    regex: new RegExp('^RTCMediaStreamTrack_(?:local|sender)_'),
    profiler: {
      type: 'kind',
      value: 'audio'
    }
  },
  rtcOutVideo: {
    regex: new RegExp('^RTCMediaStreamTrack_(?:local|sender)_'),
    profiler: {
      type: 'kind',
      value: 'video'
    }
  },
  rtcInAudio: {
    regex: new RegExp('^RTCMediaStreamTrack_(?:remote|receiver)_'),
    profiler: {
      type: 'kind',
      value: 'audio'
    }
  },
  rtcInVideo: {
    regex: new RegExp('^RTCMediaStreamTrack_(?:remote|receiver)_'),
    profiler: {
      type: 'kind',
      value: 'video'
    }
  },
  rtcTransAudio: {
    regex: new RegExp('^RTCTransport_[Aa]udio')
  },
  rtcTransVideo: {
    regex: new RegExp('^RTCTransport_[Vv]ideo')
  },
  rtcCandidatePair: {
    regex: new RegExp('^RTCIceCandidatePair_'),
    decider: 'nominated',
    selector: true,
    profiler: {
      type: 'type',
      value: 'candidate-pair'
    }
  }
}; // we need a specific firefox transform regular expression map
// to convert firefox values to a consistent getStats type mapping
// as with chrome/edge/safari

exports.DEFAULT_TRANSFORM_REGEX = DEFAULT_TRANSFORM_REGEX;
var DEFAULT_FF_TRANSFORM_REGEX = {
  rtpOutVideo: {
    regex: new RegExp('^outbound-rtp_video_.*')
  },
  rtpOutAudio: {
    regex: new RegExp('^outbound-rtp_audio_.*')
  },
  rtpInVideo: {
    regex: new RegExp('^inbound-rtp_video_.*')
  },
  rtpInAudio: {
    regex: new RegExp('^inbound-rtp_audio_.*')
  },
  rtcCandidatePair: {
    regex: new RegExp('^candidate-pair.*'),
    decider: 'nominated',
    selector: true,
    profiler: {
      type: 'type',
      value: 'candidate-pair'
    }
  }
};
exports.DEFAULT_FF_TRANSFORM_REGEX = DEFAULT_FF_TRANSFORM_REGEX;
var VALID_EMAIL_ADDRESS = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
exports.VALID_EMAIL_ADDRESS = VALID_EMAIL_ADDRESS;
var VALID_PMR_ADDRESS = /([a-z0-9][-a-z0-9, '.']{0,62})@([a-z0-9][-a-z0-9, '.']{0,62})\.webex\.com/i;
exports.VALID_PMR_ADDRESS = VALID_PMR_ADDRESS;
var VALID_PMR_LINK = /(https:\/\/)?([a-z0-9][-a-z0-9, '.']{0,62})\.webex\.com\/(meet|join)\/([a-z0-9][-a-z0-9, '.']{0,62})\/?/i;
exports.VALID_PMR_LINK = VALID_PMR_LINK;
var VALID_PIN = /([0-9]{4,6})/;
exports.VALID_PIN = VALID_PIN;
var UUID_REG = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i; // ******************** OBJECTS ********************
// Please alphabetize, and keep objects organized
// TODO:  move all api params to API section

exports.UUID_REG = UUID_REG;
var API = {
  CALLIOPEDISCOVERY: 'calliopeDiscovery',
  LOCUS: 'locus'
};
exports.API = API;
var ANALYSIS_CHECKS = {
  INCREASING: 'increasing',
  DECREASING: 'decreasing',
  CONSTANT: 'constant'
};
exports.ANALYSIS_CHECKS = ANALYSIS_CHECKS;
var ANALYSIS_STATS = {
  DEFAULT_KEYS: [{
    key: 'bytesSent',
    check: 'increasing',
    prop: 'rtpOutAudio'
  }, {
    key: 'bytesReceived',
    check: 'increasing',
    prop: 'rtpInAudio'
  }]
};
exports.ANALYSIS_STATS = ANALYSIS_STATS;
var CALENDAR_EVENTS = {
  CREATE: 'event:calendar.meeting.create',
  UPDATE: 'event:calendar.meeting.update',
  CREATE_MINIMAL: 'event:calendar.meeting.create.minimal',
  UPDATE_MINIMAL: 'event:calendar.meeting.update.minimal',
  DELETE: 'event:calendar.meeting.delete'
};
exports.CALENDAR_EVENTS = CALENDAR_EVENTS;
var DEFAULT_GET_STATS_FILTER = {
  types: ['track', 'transport', 'candidate-pair', 'outbound-rtp', 'outboundrtp', 'inbound-rtp', 'inboundrtp', 'remote-inbound-rtp', 'remote-outbound-rtp', 'remote-candidate', 'local-candidate', 'media-source']
};
exports.DEFAULT_GET_STATS_FILTER = DEFAULT_GET_STATS_FILTER;
var DEFAULT_EVENT_VIDEO_SEND_KEYS = ['rtpOutVideo', 'rtcOutVideo', 'rtcTransVideo'];
exports.DEFAULT_EVENT_VIDEO_SEND_KEYS = DEFAULT_EVENT_VIDEO_SEND_KEYS;
var DEFAULT_EVENT_AUDIO_SEND_KEYS = ['rtpOutAudio', 'rtcOutAudio', 'rtcTransAudio'];
exports.DEFAULT_EVENT_AUDIO_SEND_KEYS = DEFAULT_EVENT_AUDIO_SEND_KEYS;
var DEFAULT_EVENT_VIDEO_RECEIVE_KEYS = ['rtpInVideo', 'rtcInVideo', 'rtcTransVideo'];
exports.DEFAULT_EVENT_VIDEO_RECEIVE_KEYS = DEFAULT_EVENT_VIDEO_RECEIVE_KEYS;
var DEFAULT_EVENT_AUDIO_RECEIVE_KEYS = ['rtpInAudio', 'rtcInAudio', 'rtcTransAudio'];
exports.DEFAULT_EVENT_AUDIO_RECEIVE_KEYS = DEFAULT_EVENT_AUDIO_RECEIVE_KEYS;
var DEFAULT_TRANSFORM_KEYS = ['rtpOutVideo', 'rtpOutAudio', 'rtpInVideo', 'rtpInAudio', 'rtcOutAudio', 'rtcOutVideo', 'rtcInAudio', 'rtcInVideo', 'rtcTransAudio', 'rtcTransVideo', 'rtcCandidatePairAudio', 'rtcCandidatePairVideo']; // remove unneccessary data that stays constant during a call

exports.DEFAULT_TRANSFORM_KEYS = DEFAULT_TRANSFORM_KEYS;
var DEFAULT_OMISSION_DATA_KEYS = ['id', 'timestamp', 'type', 'ssrc', 'isRemote', 'mediaType', 'kind', 'trackId', 'transportId', 'codecId', 'mediaSourceId', 'trackIdentifier'];
exports.DEFAULT_OMISSION_DATA_KEYS = DEFAULT_OMISSION_DATA_KEYS;
var DELTAEVENT = {
  GT: 'GT',
  CF: 'CF',
  EQ: 'EQ',
  LT: 'LT'
};
exports.DELTAEVENT = DELTAEVENT;
var RECORDING_STATE = {
  RECORDING: 'recording',
  IDLE: 'idle',
  PAUSED: 'paused',
  RESUMED: 'resumed'
};
exports.RECORDING_STATE = RECORDING_STATE;
var SHARE_STATUS = {
  NO_SHARE: 'no_share',
  REMOTE_SHARE_ACTIVE: 'remote_share_active',
  LOCAL_SHARE_ACTIVE: 'local_share_active',
  WHITEBOARD_SHARE_ACTIVE: 'whiteboard_share_active'
}; // TODO: do we want to scope by meeting, members when they come off those objects themselves?

exports.SHARE_STATUS = SHARE_STATUS;
var EVENT_TRIGGERS = {
  MEETINGS_READY: 'meetings:ready',
  MEETINGS_REGISTERED: 'meetings:registered',
  MEETINGS_UNREGISTERED: 'meetings:unregistered',
  MEDIA_READY: 'media:ready',
  MEDIA_STOPPED: 'media:stopped',
  MEDIA_UPDATE: 'media:update',
  MEDIA_CODEC_MISSING: 'media:codec:missing',
  MEDIA_CODEC_LOADED: 'media:codec:loaded',
  MEETING_STARTED_SHARING_LOCAL: 'meeting:startedSharingLocal',
  MEETING_STOPPED_SHARING_LOCAL: 'meeting:stoppedSharingLocal',
  MEETING_STARTED_SHARING_REMOTE: 'meeting:startedSharingRemote',
  MEETING_STOPPED_SHARING_REMOTE: 'meeting:stoppedSharingRemote',
  MEETING_STARTED_SHARING_WHITEBOARD: 'meeting:startedSharingWhiteboard',
  MEETING_STOPPED_SHARING_WHITEBOARD: 'meeting:stoppedSharingWhiteboard',
  MEETING_MEDIA_LOCAL_STARTED: 'meeting:media:local:start',
  MEETING_MEDIA_REMOTE_STARTED: 'meeting:media:remote:start',
  MEETING_STARTED_RECORDING: 'meeting:recording:started',
  MEETING_STOPPED_RECORDING: 'meeting:recording:stopped',
  MEETING_STARTED_RECEIVING_TRANSCRIPTION: 'meeting:receiveTranscription:started',
  MEETING_STOPPED_RECEIVING_TRANSCRIPTION: 'meeting:receiveTranscription:stopped',
  MEETING_PAUSED_RECORDING: 'meeting:recording:paused',
  MEETING_RESUMED_RECORDING: 'meeting:recording:resumed',
  MEETING_ADDED: 'meeting:added',
  MEETING_REMOVED: 'meeting:removed',
  MEETING_RINGING: 'meeting:ringing',
  MEETING_RINGING_STOP: 'meeting:ringingStop',
  MEETING_SELF_LOBBY_WAITING: 'meeting:self:lobbyWaiting',
  MEETING_SELF_GUEST_ADMITTED: 'meeting:self:guestAdmitted',
  MEETING_SELF_MUTED_BY_OTHERS: 'meeting:self:mutedByOthers',
  MEETING_SELF_UNMUTED_BY_OTHERS: 'meeting:self:unmutedByOthers',
  MEETING_SELF_REQUESTED_TO_UNMUTE: 'meeting:self:requestedToUnmute',
  MEETING_SELF_PHONE_AUDIO_UPDATE: 'meeting:self:phoneAudioUpdate',
  MEMBERS_UPDATE: 'members:update',
  MEMBERS_CONTENT_UPDATE: 'members:content:update',
  MEMBERS_HOST_UPDATE: 'members:host:update',
  MEMBERS_SELF_UPDATE: 'members:self:update',
  MEETING_RECONNECTION_STARTING: 'meeting:reconnectionStarting',
  MEETING_RECONNECTION_SUCCESS: 'meeting:reconnectionSuccess',
  MEETING_RECONNECTION_FAILURE: 'meeting:reconnectionFailure',
  MEETING_UNLOCKED: 'meeting:unlocked',
  MEETING_LOCKED: 'meeting:locked',
  MEETING_LOG_UPLOAD_SUCCESS: 'meeting:logUpload:success',
  MEETING_LOG_UPLOAD_FAILURE: 'meeting:logUpload:failure',
  MEETING_ACTIONS_UPDATE: 'meeting:actionsUpdate',
  MEETING_STATE_CHANGE: 'meeting:stateChange',
  MEETING_HIGH_PACKETLOSS: 'meeting:highPacketLoss',
  MEDIA_QUALITY: 'media:quality',
  MEETINGS_NETWORK_DISCONNECTED: 'network:disconnected',
  MEETINGS_NETWORK_CONNECTED: 'network:connected',
  MEETING_SELF_LEFT: 'meeting:self:left',
  NETWORK_QUALITY: 'network:quality',
  MEDIA_NEGOTIATED: 'media:negotiated'
};
exports.EVENT_TRIGGERS = EVENT_TRIGGERS;
var EVENT_TYPES = {
  SELF: 'self',
  OTHER: 'other',
  LOCAL: 'local',
  REMOTE: 'remote',
  REMOTE_AUDIO: 'remoteAudio',
  REMOTE_VIDEO: 'remoteVideo',
  REMOTE_SHARE: 'remoteShare',
  LOCAL_SHARE: 'localShare',
  ERROR: 'error'
}; // Handles the reason when meeting gets destroyed
// host removed you from the meeting
// You are the host and you left the meeting
// Meeting actually ended

exports.EVENT_TYPES = EVENT_TYPES;
var MEETING_REMOVED_REASON = {
  SELF_REMOVED: 'SELF_REMOVED',
  // server or host removed you from the meeting
  FULLSTATE_REMOVED: 'FULLSTATE_REMOVED',
  // meeting got dropped ? not sure
  MEETING_INACTIVE_TERMINATING: 'MEETING_INACTIVE_TERMINATING',
  // Meeting got ended or everyone left the meeting
  CLIENT_LEAVE_REQUEST: 'CLIENT_LEAVE_REQUEST',
  // You triggered leave meeting
  USER_ENDED_SHARE_STREAMS: 'USER_ENDED_SHARE_STREAMS',
  // user triggered stop share
  NO_MEETINGS_TO_SYNC: 'NO_MEETINGS_TO_SYNC',
  // After the syncMeeting no meeting exists
  MEETING_CONNECTION_FAILED: 'MEETING_CONNECTION_FAILED' // meeting failed to connect due to ice failures or firewall issue

}; // One one one calls ends for the following reasons
// Partner reject the call or ends the call
// self cancel or end the ongoing call

exports.MEETING_REMOVED_REASON = MEETING_REMOVED_REASON;
var CALL_REMOVED_REASON = {
  CALL_INACTIVE: 'CALL_INACTIVE',
  // partner and you leave the call
  PARTNER_LEFT: 'PARTNER_LEFT',
  // partner left the call
  SELF_LEFT: 'SELF_LEFT' // you left/declined the call

};
exports.CALL_REMOVED_REASON = CALL_REMOVED_REASON;
var SHARE_STOPPED_REASON = {
  SELF_STOPPED: 'SELF_STOPPED',
  MEETING_REJOIN: 'MEETING_REJOIN'
};
exports.SHARE_STOPPED_REASON = SHARE_STOPPED_REASON;
var EVENTS = {
  ROAP_OK: 'ROAP_OK',
  ROAP_ANSWER: 'ROAP_ANSWER',
  SELF_UNADMITTED_GUEST: 'SELF_UNADMITTED_GUEST',
  SELF_ADMITTED_GUEST: 'SELF_ADMITTED_GUEST',
  MEDIA_INACTIVITY: 'MEDIA_INACTIVITY',
  CONVERSATION_URL_UPDATE: 'CONVERSATION_URL_UPDATE',
  DESTROY_MEETING: 'DESTROY_MEETING',
  REQUEST_UPLOAD_LOGS: 'REQUEST_UPLOAD_LOGS',
  REMOTE_RESPONSE: 'REMOTE_RESPONSE',
  // TODO: move all of these to LOCUSINFO.EVENTS
  LOCUS_INFO_UPDATE_PARTICIPANTS: 'LOCUS_INFO_UPDATE_PARTICIPANTS',
  LOCUS_INFO_UPDATE_HOST: 'LOCUS_INFO_UPDATE_HOST',
  LOCUS_INFO_UPDATE_MEDIA_SHARES: 'LOCUS_INFO_UPDATE_MEDIA_SHARES',
  LOCUS_INFO_UPDATE_SELF: 'LOCUS_INFO_UPDATE_SELF',
  LOCUS_INFO_UPDATE_URL: 'LOCUS_INFO_UPDATE_URL',
  LOCUS_INFO_CAN_ASSIGN_HOST: 'LOCUS_INFO_CAN_ASSIGN_HOST',
  DISCONNECT_DUE_TO_INACTIVITY: 'DISCONNECT_DUE_TO_INACTIVITY'
};
exports.EVENTS = EVENTS;
var MEDIA_STATE = {
  active: 'active',
  inactive: 'inactive'
};
exports.MEDIA_STATE = MEDIA_STATE;
var EVENT_STATS_MAP = {
  BYTES_SENT: 'bytesSent',
  BYTES_RECEIVED: 'bytesReceived'
};
exports.EVENT_STATS_MAP = EVENT_STATS_MAP;
var ERROR_DICTIONARY = {
  PARAMETER: {
    NAME: 'ParameterError',
    MESSAGE: 'The parameters passed to the function, or object properties needed in the function were null, missing where required, or otherwise incorrect.',
    CODE: 0
  },
  INTENT_TO_JOIN: {
    NAME: 'IntentToJoinError',
    MESSAGE: 'The meeting is locked. This is expected behavior. Call #join again with pin and/or moderator option',
    CODE: 1
  },
  JOIN_MEETING: {
    NAME: 'JoinMeetingError',
    MESSAGE: 'There was an issue joining the meeting, meeting could be in a bad state.',
    CODE: 2
  },
  RECONNECTION: {
    NAME: 'ReconnectionError',
    MESSAGE: 'There was an error in the reconnection flow, the meeting may not reconnect, disconnect and dial again.',
    CODE: 3
  },
  MEDIA: {
    NAME: 'MediaError',
    MESSAGE: 'There was an error with media, the meeting may not have live audio, video or share.',
    CODE: 4
  },
  PERMISSION: {
    NAME: 'PermissionError',
    MESSAGE: 'Not allowed to execute the function, some properties on server, or local client state do not allow you to complete this action.',
    CODE: 5
  },
  STATS: {
    NAME: 'StatsError',
    MESSAGE: 'An error occurred with getStats, stats may not continue for this data stream.',
    CODE: 6
  },
  PASSWORD: {
    NAME: 'PasswordError',
    MESSAGE: 'Password is required, please use verifyPassword()',
    CODE: 7
  },
  CAPTCHA: {
    NAME: 'CaptchaError',
    MESSAGE: 'Captcha is required.',
    CODE: 8
  }
};
exports.ERROR_DICTIONARY = ERROR_DICTIONARY;
var FLOOR_ACTION = {
  GRANTED: 'GRANTED',
  RELEASED: 'RELEASED',
  ACCEPTED: 'ACCEPTED'
};
exports.FLOOR_ACTION = FLOOR_ACTION;
var FULL_STATE = {
  INITIALIZING: 'INITIALIZING',
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  TERMINATING: 'TERMINATING',
  UNKNOWN: 'UNKNOWN'
};
exports.FULL_STATE = FULL_STATE;
var HTTP_VERBS = {
  PUT: 'PUT',
  POST: 'POST',
  GET: 'GET',
  PATCH: 'PATCH'
}; // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/iceGatheringState

exports.HTTP_VERBS = HTTP_VERBS;
var ICE_GATHERING_STATE = {
  NEW: 'new',
  GATHERING: 'gathering',
  COMPLETE: 'complete'
}; // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/iceConnectionState

exports.ICE_GATHERING_STATE = ICE_GATHERING_STATE;
var ICE_STATE = {
  CHECKING: 'checking',
  CONNECTED: 'connected',
  CLOSED: 'closed',
  COMPLETED: 'completed',
  FAILED: 'failed',
  DISCONNECTED: 'disconnected'
};
exports.ICE_STATE = ICE_STATE;
var CONNECTION_STATE = {
  NEW: 'new',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  CLOSED: 'closed',
  FAILED: 'failed',
  DISCONNECTED: 'disconnected'
};
exports.CONNECTION_STATE = CONNECTION_STATE;
var JOIN_HINTS = {
  LOCK_STATUS_LOCKED: 'LOCK_STATUS_LOCKED',
  LOCK_STATUS_UNLOCKED: 'LOCK_STATUS_UNLOCKED'
};
exports.JOIN_HINTS = JOIN_HINTS;
var LOCUS = {
  STATE: {
    INACTIVE: 'INACTIVE',
    ENDED: 'ENDED',
    INITIALIZING: 'INITIALIZING'
  },
  SEQUENCE: {
    UN_DEF: 'undef',
    EMPTY: 'empty',
    DEF: 'def',
    NA: 'na',
    RANGE_START: 'rangeStart',
    RANGE_END: 'rangeEnd'
  },
  SYNCDEBUG: 'sync_debug'
};
exports.LOCUS = LOCUS;
var LOCUSINFO = {
  EVENTS: {
    CONTROLS_RECORDING_UPDATED: 'CONTROLS_RECORDING_UPDATED',
    SELF_UNADMITTED_GUEST: 'SELF_UNADMITTED_GUEST',
    SELF_ADMITTED_GUEST: 'SELF_ADMITTED_GUEST',
    SELF_REMOTE_MUTE_STATUS_UPDATED: 'SELF_REMOTE_MUTE_STATUS_UPDATED',
    LOCAL_UNMUTE_REQUESTED: 'LOCAL_UNMUTE_REQUESTED',
    LOCAL_UNMUTE_REQUIRED: 'LOCAL_UNMUTE_REQUIRED',
    SELF_MODERATOR_CHANGED: 'SELF_MODERATOR_CHANGED',
    MEETING_UPDATE: 'MEETING_UPDATE',
    MEDIA_STATUS_CHANGE: 'MEDIA_STATUS_CHANGE',
    FULL_STATE_TYPE_UPDATE: 'FULL_STATE_TYPE_UPDATE',
    FULL_STATE_MEETING_STATE_CHANGE: 'FULL_STATE_MEETING_STATE_CHANGE',
    MEETING_STATE_CHANGE_TO_ACTIVE: 'MEETING_STATE_CHANGE_TO_ACTIVE',
    MEETING_INFO_UPDATED: 'MEETING_INFO_UPDATED',
    MEETING_LOCKED: 'MEETING_LOCKED',
    MEETING_UNLOCKED: 'MEETING_UNLOCKED',
    DISCONNECT_DUE_TO_INACTIVITY: 'DISCONNECT_DUE_TO_INACTIVITY'
  }
};
exports.LOCUSINFO = LOCUSINFO;
var LOCUSEVENT = {
  LOCUS_MERCURY: 'event:locus',
  // update the tp unit status
  CONTROLS_UPDATED: 'locus.controls_updated',
  // delta events
  DIFFERENCE: 'locus.difference',
  // screen sharing
  FLOOR_GRANTED: 'locus.floor_granted',
  FLOOR_RELEASED: 'locus.floor_released',
  // Roap
  MESSAGE_ROAP: 'locus.message.roap',
  // Join events
  PARTICIPANT_JOIN: 'locus.participant_joined',
  PARTICIPANT_LEFT: 'locus.participant_left',
  PARTICIPANT_DECLINED: 'locus.participant_declined',
  PARTICIPANT_UPDATED: 'locus.participant_updated',
  PARTICIPANT_CONTROLS_UPDATED: 'locus.participant_controls_updated',
  PARTICIPANT_ROLES_UPDATED: 'locus.participant_roles_updated',
  PARTICIPANT_AUDIO_MUTED: 'locus.participant_audio_muted',
  PARTICIPANT_AUDIO_UNMUTED: 'locus.participant_audio_unmuted',
  PARTICIPANT_VIDEO_MUTED: 'locus.participant_video_muted',
  PARTICIPANT_VIDEO_UNMUTED: 'locus.participant_video_unmuted',
  RECORDING_STARTED: 'locus.recording_started',
  RECORDING_START_FAILED: 'locus.recording_start_failed',
  RECORDING_STOPPED: 'locus.recording_stopped',
  SELF_CHANGED: 'locus.self_changed'
};
exports.LOCUSEVENT = LOCUSEVENT;
var MEDIA_TRACK_CONSTRAINT = {
  CURSOR: {
    // The mouse cursor should always be captured in the generated stream.
    AWLAYS: 'always',
    // The cursor should only be visible while moving, then removed.
    MOTION: 'motion',
    // The cursor should never be visible in the generated stream.
    NEVER: 'never'
  }
};
exports.MEDIA_TRACK_CONSTRAINT = MEDIA_TRACK_CONSTRAINT;
var MEETING_ERRORS = {
  METRICS_NOT_SERVER_OR_CLIENT_EXCEPTION: 'METRICS_NOT_SERVER_OR_CLIENT_EXCEPTION',
  BIDIRECTIONAL_ROSTER_NOT_ALLOWED: 'BIDIRECTIONAL_ROSTER_NOT_ALLOWED',
  INVALID_LOCUS_URL: 'INVALID_LOCUS_URL',
  ARGUMENT_NULL_OR_EMPTY: 'ARGUMENT_NULL_OR_EMPTY',
  INVALID_USER: 'INVALID_USER',
  INVALID_PHONE_NUMBER_OR_COUNTRY_CODE: 'INVALID_PHONE_NUMBER_OR_COUNTRY_CODE',
  EMPTY_PHONE_NUMBER_OR_COUNTRY_CODE: 'EMPTY_PHONE_NUMBER_OR_COUNTRY_CODE',
  PHONE_NUMBER_INVALID_COUNTRY_CODE: 'PHONE_NUMBER_INVALID_COUNTRY_CODE',
  PHONE_NUMBER_NOT_A_NUMBER: 'PHONE_NUMBER_NOT_A_NUMBER',
  PHONE_NUMBER_TOO_SHORT_AFTER_IDD: 'PHONE_NUMBER_TOO_SHORT_AFTER_IDD',
  PHONE_NUMBER_TOO_SHORT_NSN: 'PHONE_NUMBER_TOO_SHORT_NSN',
  PHONE_NUMBER_TOO_LONG: 'PHONE_NUMBER_TOO_LONG',
  INVALID_DIALABLE_KEY: 'INVALID_DIALABLE_KEY',
  INVALID_MEETING_LINK: 'INVALID_MEETING_LINK',
  INVALID_SINCE_OR_SEQUENCE_HASH_IN_REQUEST: 'INVALID_SINCE_OR_SEQUENCE_HASH_IN_REQUEST',
  INVALID_LOCUS_ID: 'INVALID_LOCUS_ID',
  EMPTY_SCHEDULED_MEETING_START_TIME: 'EMPTY_SCHEDULED_MEETING_START_TIME',
  INVALID_SCHEDULED_MEETING_DURATION_MINUTES: 'INVALID_SCHEDULED_MEETING_DURATION_MINUTES',
  INVALID_SCHEDULED_MEETING_REMINDER_DURATION_MINUTES: 'INVALID_SCHEDULED_MEETING_REMINDER_DURATION_MINUTES',
  EMPTY_SCHEDULED_MEETING_ORGANIZER: 'EMPTY_SCHEDULED_MEETING_ORGANIZER',
  INVALID_MEETING_ID_FORMAT: 'INVALID_MEETING_ID_FORMAT',
  INVALID_SIP_URL_FORMAT: 'INVALID_SIP_URL_FORMAT',
  EMPTY_INVITEE_RECORD: 'EMPTY_INVITEE_RECORD',
  EMPTY_INVITEE_ADDRESS: 'EMPTY_INVITEE_ADDRESS',
  DESKPHONE_NOTHING_DIALABLE_FOUND: 'DESKPHONE_NOTHING_DIALABLE_FOUND',
  INVALID_INVITEE_ADDRESS: 'INVALID_INVITEE_ADDRESS',
  INVALID_ATTENDEE_ID: 'INVALID_ATTENDEE_ID',
  INVALID_IN_LOBBY: 'INVALID_IN_LOBBY',
  MISSING_REQUESTING_PARTICIPANT_ID: 'MISSING_REQUESTING_PARTICIPANT_ID',
  INVALID_REQUESTING_PARTICIPANT_ID: 'INVALID_REQUESTING_PARTICIPANT_ID',
  SUPPLEMENTARY_USER_INFO_NOT_FOUND: 'SUPPLEMENTARY_USER_INFO_NOT_FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
  REMOVED_PARTICIPANT: 'REMOVED_PARTICIPANT',
  FREE_USER_MAX_PARTICIPANTS_EXCEEDED: 'FREE_USER_MAX_PARTICIPANTS_EXCEEDED',
  PAID_USER_MAX_PARTICIPANTS_EXCEEDED: 'PAID_USER_MAX_PARTICIPANTS_EXCEEDED',
  SERVICE_MAX_PARTICIPANTS_EXCEEDED: 'SERVICE_MAX_PARTICIPANTS_EXCEEDED',
  INACTIVE: 'INACTIVE',
  ONE_ON_ONE_TO_SELF_NOT_ALLOWED: 'ONE_ON_ONE_TO_SELF_NOT_ALLOWED',
  JOIN_RESTRICTED_USER: 'JOIN_RESTRICTED_USER',
  GET_RESTRICTED_USER: 'GET_RESTRICTED_USER',
  JOIN_RESTRICTED_USER_NOT_IN_ROOM: 'JOIN_RESTRICTED_USER_NOT_IN_ROOM',
  CREATE_MEDIA_RESTRICTED_USER: 'CREATE_MEDIA_RESTRICTED_USER',
  DUPLICATE_RESOURCE_CREATION_REQUEST: 'DUPLICATE_RESOURCE_CREATION_REQUEST',
  MEETING_NOT_FOUND: 'MEETING_NOT_FOUND',
  NOT_WEBEX_SITE: 'NOT_WEBEX_SITE',
  INVALID_SCHEDULED_MEETING_ORGANIZER: 'INVALID_SCHEDULED_MEETING_ORGANIZER',
  FREE_USER_MAX_PARTICIPANTS_JOINED_EXCEEDED: 'FREE_USER_MAX_PARTICIPANTS_JOINED_EXCEEDED',
  PAID_USER_MAX_PARTICIPANTS_JOINED_EXCEEDED: 'PAID_USER_MAX_PARTICIPANTS_JOINED_EXCEEDED',
  SERVICE_MAX_PARTICIPANTS_ROSTER_EXCEEDED: 'SERVICE_MAX_PARTICIPANTS_ROSTER_EXCEEDED',
  SERVICE_INITIAL_PARTICIPANTS_ROSTER_EXCEEDED: 'SERVICE_INITIAL_PARTICIPANTS_ROSTER_EXCEEDED',
  RESOURCE_GUEST_FORBIDDEN: 'RESOURCE_GUEST_FORBIDDEN',
  SERVICE_NO_MACHINE_OR_SERVICE_ACCOUNT: 'SERVICE_NO_MACHINE_OR_SERVICE_ACCOUNT',
  MODERATOR_ROLE_REMOVAL_NOT_ALLOWED: 'MODERATOR_ROLE_REMOVAL_NOT_ALLOWED',
  RECORDING_CONTROL_NOT_SUPPORTED: 'RECORDING_CONTROL_NOT_SUPPORTED',
  HOST_PIN_LOCKED: 'HOST_PIN_LOCKED',
  INVALID_HOST_PIN: 'INVALID_HOST_PIN',
  REQUESTING_PARTICIPANT_NOT_MODERATOR: 'REQUESTING_PARTICIPANT_NOT_MODERATOR',
  CONVERSATION_NOT_FOUND: 'CONVERSATION_NOT_FOUND',
  MEETING_LINK_NOT_FOUND: 'MEETING_LINK_NOT_FOUND',
  MEETING_INFO_NOT_FOUND: 'MEETING_INFO_NOT_FOUND',
  SCHEDULED_MEETING_NOT_FOUND: 'SCHEDULED_MEETING_NOT_FOUND',
  RECORDING_NOT_STARTED: 'RECORDING_NOT_STARTED',
  RECORDING_NOT_ENABLED: 'RECORDING_NOT_ENABLED',
  RECORDING_USER_STORAGE_FULL: 'RECORDING_USER_STORAGE_FULL',
  RECORDING_SITE_STORAGE_FULL: 'RECORDING_SITE_STORAGE_FULL',
  NO_SCHEDULED_MEETING: 'NO_SCHEDULED_MEETING',
  MEETING_FULL_UPDATE_NOT_ALLOWED: 'MEETING_FULL_UPDATE_NOT_ALLOWED',
  MODERATOR_ROLE_REMOVAL_NOT_VALID: 'MODERATOR_ROLE_REMOVAL_NOT_VALID',
  MODERATOR_ROLE_ADDITION_NOT_VALID: 'MODERATOR_ROLE_ADDITION_NOT_VALID',
  INVALID_CALL_START_TIME: 'INVALID_CALL_START_TIME',
  MEETING_STARTED_UPDATE_NOT_ALLOWED: 'MEETING_STARTED_UPDATE_NOT_ALLOWED',
  EXCEEDED_MAX_JOINED_PARTICIPANTS: 'EXCEEDED_MAX_JOINED_PARTICIPANTS',
  EXCEEDED_SERVICE_MAX_PARTICIPANTS: 'EXCEEDED_SERVICE_MAX_PARTICIPANTS',
  MEETING_IS_LOCKED: 'MEETING_IS_LOCKED',
  MEETING_IS_TERMINATING: 'MEETING_IS_TERMINATING',
  MEETING_REQUIRE_MODERATOR_PIN_INTENT: 'MEETING_REQUIRE_MODERATOR_PIN_INTENT',
  MEETING_REQUIRE_MODERATOR_PIN: 'MEETING_REQUIRE_MODERATOR_PIN',
  MEETING_REQUIRE_MODERATOR_ROLE: 'MEETING_REQUIRE_MODERATOR_ROLE',
  PMR_ACCOUNT_SUSPENDED: 'PMR_ACCOUNT_SUSPENDED',
  PMR_ACCOUNT_LOCKED: 'PMR_ACCOUNT_LOCKED',
  INVALID_JOIN_TIME: 'INVALID_JOIN_TIME',
  REQUIRES_WEBEX_LOGIN: 'REQUIRES_WEBEX_LOGIN',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
  UNABLE_TO_LOOK_UP_DEVICE_INFORMATION: 'UNABLE_TO_LOOK_UP_DEVICE_INFORMATION',
  UNABLE_TO_LOOK_UP_CONVERSATION: 'UNABLE_TO_LOOK_UP_CONVERSATION',
  UNABLE_TO_LOOK_UP_CI_USER: 'UNABLE_TO_LOOK_UP_CI_USER',
  UNABLE_TO_CREATE_CONFLUENCE: 'UNABLE_TO_CREATE_CONFLUENCE',
  SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
  SOCKET_TIMEOUT: 'SOCKET_TIMEOUT',
  NO_HTTP_RESPONSE: 'NO_HTTP_RESPONSE'
};
exports.MEETING_ERRORS = MEETING_ERRORS;
var MEETING_END_REASON = {
  INACTIVE: 'INACTIVE',
  MEDIA_RELEASED: 'MEDIA_RELEASED'
};
exports.MEETING_END_REASON = MEETING_END_REASON;
var MODERATOR_HINTS = {
  RECORDING_CONTROL_START: 'RECORDING_CONTROL_START',
  RECORDING_CONTROL_PAUSE: 'RECORDING_CONTROL_PAUSE',
  RECORDING_CONTROL_STOP: 'RECORDING_CONTROL_STOP',
  RECORDING_CONTROL_RESUME: 'RECORDING_CONTROL_RESUME',
  LOCK_CONTROL_UNLOCK: 'LOCK_CONTROL_UNLOCK',
  LOCK_CONTROL_LOCK: 'LOCK_CONTROL_LOCK'
};
exports.MODERATOR_HINTS = MODERATOR_HINTS;
var MEETING_STATE = {
  STATES: {
    IDLE: 'IDLE',
    INCOMING: 'INCOMING',
    DIALING: 'DIALING',
    NOTIFIED: 'NOTIFIED',
    DECLINED: 'DECLINED',
    ON_GOING: 'ON_GOING',
    JOINED: 'JOINED',
    TERMINATING: 'TERMINATING',
    LEFT: 'LEFT',
    ENDED: 'ENDED',
    ERROR: 'ERROR'
  }
};
exports.MEETING_STATE = MEETING_STATE;
var MEETING_STATE_MACHINE = {
  TRANSITIONS: {
    FAIL: 'fail',
    RING: 'ring',
    REMOTE: 'remote',
    JOIN: 'join',
    DECLINE: 'decline',
    LEAVE: 'leave',
    RESET: 'reset'
  },
  STATES: {
    ERROR: 'ERROR',
    IDLE: 'IDLE',
    ENDED: 'ENDED',
    DECLINED: 'DECLINED',
    RINGING: 'RINGING',
    JOINED: 'JOINED',
    ANSWERED: 'ANSWERED'
  }
};
exports.MEETING_STATE_MACHINE = MEETING_STATE_MACHINE;
var MEETING_AUDIO_STATE_MACHINE = {
  TRANSITIONS: {
    TOGGLE: 'toggle',
    INIT: 'init'
  },
  STATES: {
    MUTE_SELF: 'SELF_AUDIO_OFF',
    UNMUTE_SELF: 'SELF_AUDIO_ON'
  }
};
exports.MEETING_AUDIO_STATE_MACHINE = MEETING_AUDIO_STATE_MACHINE;
var MEETING_VIDEO_STATE_MACHINE = {
  TRANSITIONS: {
    TOGGLE: 'toggle',
    INIT: 'init'
  },
  STATES: {
    MUTE_SELF: 'SELF_VIDEO_OFF',
    UNMUTE_SELF: 'SELF_VIDEO_ON'
  }
};
exports.MEETING_VIDEO_STATE_MACHINE = MEETING_VIDEO_STATE_MACHINE;
var PEER_CONNECTION_STATE = {
  CLOSED: 'closed',
  FAILED: 'failed'
};
exports.PEER_CONNECTION_STATE = PEER_CONNECTION_STATE;
var RTC_CONFIGURATION_FIREFOX = {
  iceServers: [],
  bundlePolicy: 'max-compat'
};
exports.RTC_CONFIGURATION_FIREFOX = RTC_CONFIGURATION_FIREFOX;
var RTC_CONFIGURATION = {
  iceServers: []
};
exports.RTC_CONFIGURATION = RTC_CONFIGURATION;
var RECONNECTION = {
  STATE: {
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETE: 'COMPLETE',
    FAILURE: 'FAILURE',
    DEFAULT_TRY_COUNT: 0,
    DEFAULT_STATUS: ''
  }
};
exports.RECONNECTION = RECONNECTION;
var RESOURCE = {
  CLUSTERS: 'clusters',
  REACHABILITY: 'reachability',
  LOCI: 'loci'
};
exports.RESOURCE = RESOURCE;
var REACHABILITY = {
  localStorage: 'reachability.result'
};
exports.REACHABILITY = REACHABILITY;
var ROAP = {
  ROAP_TRANSITIONS: {
    STEP: 'step'
  },
  ROAP_TYPES: {
    OFFER: 'OFFER',
    ANSWER: 'ANSWER',
    OK: 'OK',
    ERROR: 'ERROR',
    SHUTDOWN: 'SHUTDOWN',
    OFFER_REQUEST: 'OFFER_REQUEST'
  },
  ROAP_STATE: {
    INIT: 'INIT',
    WAIT_RX_OFFER: 'WAIT_RX_OFFER',
    WAIT_RX_ANSWER: 'WAIT_RX_ANSWER',
    WAIT_RX_OK: 'WAIT_RX_OK',
    WAIT_TX_OFFER: 'WAIT_TX_OFFER',
    WAIT_TX_ANSWER: 'WAIT_TX_ANSWER',
    WAIT_TX_OK: 'WAIT_TX_OK',
    IDLE_LOCAL_OFFER: 'IDLE_LOCAL_OFFER',
    IDLE_REMOTE_OFFER: 'IDLE_REMOTE_OFFER',
    GLARE: 'GLARE',
    ERROR: 'ERROR'
  },
  ROAP_SIGNAL: {
    RX_OFFER: 'RX_OFFER',
    TX_OFFER: 'TX_OFFER',
    RX_ANSWER: 'RX_ANSWER',
    TX_ANSWER: 'TX_ANSWER',
    RX_OK: 'RX_OK',
    TX_OK: 'TX_OK',
    GLARE_RESOLVED: 'GLARE_RESOLVED'
  },
  RECEIVE_ROAP_MSG: 'RECEIVE_ROAP_MSG',
  SEND_ROAP_MSG: 'SEND_ROAP_MSG',
  SEND_ROAP_MSG_SUCCESS: 'SEND_ROAP_MSG_SUCCESS',
  RESET_ROAP_STATE: 'RESET_ROAP_STATE',
  RECEIVE_CALL_LEAVE: 'RECEIVE_CALL_LEAVE',
  ROAP_MERCURY: 'event:locus.message.roap',
  ROAP_VERSION: '2',
  RX_: 'RX_',
  TX_: 'TX_'
};
exports.ROAP = ROAP;
var MediaContent = {
  main: 'main',
  slides: 'slides'
};
exports.MediaContent = MediaContent;
var SDP = {
  A_CONTENT_SLIDES: 'a=content:slides',
  ROLLBACK: 'rollback',
  HAVE_LOCAL_OFFER: 'have-local-offer',
  HAVE_REMOTE_OFFER: 'have-remote-offer',
  STABLE: 'stable',
  OFFER: 'offer',
  M_LINE: 'm=',
  MAX_FS: 'max-fs=',
  B_LINE: 'b=TIAS',
  // Edonus repeated key frames request
  PERIODIC_KEYFRAME: 'a=periodic-keyframes:20',
  CARRIAGE_RETURN: '\r\n',
  BAD_MEDIA_PORTS: [0]
};
exports.SDP = SDP;
var NETWORK_STATUS = {
  DISCONNECTED: 'DISCONNECTED',
  RECONNECTING: 'RECONNECTING',
  CONNECTED: 'CONNECTED'
};
exports.NETWORK_STATUS = NETWORK_STATUS;
var NETWORK_TYPE = {
  VPN: 'vpn',
  UNKNOWN: 'unknown',
  WIFI: 'wifi',
  ETHERNET: 'ethernet'
};
exports.NETWORK_TYPE = NETWORK_TYPE;
var STATS = {
  AUDIO_CORRELATE: 'audio',
  VIDEO_CORRELATE: 'video',
  SHARE_CORRELATE: 'share',
  AUDIO_SENDER_ID: 'audioSender',
  AUDIO_RECEIVER_ID: 'audioReceiver',
  VIDEO_SENDER_ID: 'videoSender',
  VIDEO_RECEIVER_ID: 'videoReceiver',
  SHARE_SENDER_ID: 'shareSender',
  SHARE_RECEIVER_ID: 'shareReceiver',
  SEND_DIRECTION: 'send',
  RECEIVE_DIRECTION: 'recv',
  END: 'end',
  REMOTE: 'remote',
  LOCAL: 'local',
  DATA: 'data',
  CLOSED: 'closed',
  SENDER: 'sender',
  RECEIVER: 'receiver',
  SENDERS: 'senders',
  RECEIVERS: 'receivers',
  CONFIG: {
    senders: {
      audio: {
        transceiver: 'audioTransceiver',
        child: 'sender',
        parent: 'mediaProperties',
        peerConnection: 'peerConnection',
        name: 'audioSender'
      },
      video: {
        transceiver: 'videoTransceiver',
        child: 'sender',
        parent: 'mediaProperties',
        peerConnection: 'peerConnection',
        name: 'videoSender'
      },
      share: {
        transceiver: 'shareTransceiver',
        child: 'sender',
        parent: 'mediaProperties',
        peerConnection: 'peerConnection',
        name: 'shareSender'
      }
    },
    receivers: {
      audio: {
        transceiver: 'audioTransceiver',
        child: 'receiver',
        parent: 'mediaProperties',
        peerConnection: 'peerConnection',
        name: 'audioReceiver'
      },
      video: {
        transceiver: 'videoTransceiver',
        child: 'receiver',
        parent: 'mediaProperties',
        peerConnection: 'peerConnection',
        name: 'videoReceiver'
      },
      share: {
        transceiver: 'shareTransceiver',
        child: 'receiver',
        parent: 'mediaProperties',
        peerConnection: 'peerConnection',
        name: 'shareReceiver'
      }
    }
  }
};
exports.STATS = STATS;
var MQA_STATS = {
  MQA_SIZE: 120,
  // MQA is done on 60 second intervals by server def, add a buffer for missed events
  CA_TYPE: 'MQA',
  DEFAULT_IP: '0.0.0.0',
  DATA_PLACEMENTS: [STATS.AUDIO_SENDER_ID, STATS.AUDIO_RECEIVER_ID, STATS.VIDEO_SENDER_ID, STATS.VIDEO_RECEIVER_ID, STATS.SHARE_SENDER_ID, STATS.SHARE_RECEIVER_ID],
  DEFAULT_SHARE_SENDER_STATS: {
    common: {
      common: {
        direction: 'sendrecv',
        // TODO: parse from SDP and save globally
        isMain: false,
        // always true for share sender
        mariFecEnabled: false,
        // unavailable
        mariQosEnabled: false,
        // unavailable
        multistreamEnabled: false // unavailable

      },
      availableBitrate: 0,
      dtlsBitrate: 0,
      // unavailable
      dtlsPackets: 0,
      // unavailable
      fecBitrate: 0,
      // unavailable
      fecPackets: 0,
      // unavailable
      maxBitrate: 0,
      // unavailable
      queueDelay: 0,
      // unavailable
      remoteJitter: 0,
      // unavailable
      remoteLossRate: 0,
      remoteReceiveRate: 0,
      // unavailable
      roundTripTime: 0,
      rtcpBitrate: 0,
      // unavailable
      rtcpPackets: 0,
      // unavailable
      rtpBitrate: 0,
      // unavailable
      rtpPackets: 0,
      stunBitrate: 0,
      // unavailable
      stunPackets: 0,
      // unavailable
      transportType: 'UDP' // TODO: parse the transport type from the SDP and save globally

    },
    streams: [{
      common: {
        codec: 'H264',
        // TODO: parse the codec from the SDP and save globally
        duplicateSsci: 0,
        // unavailable
        requestedBitrate: 0,
        // unavailable
        requestedFrames: 0,
        // unavailable
        rtpPackets: 0,
        ssci: 0,
        // unavailable
        transmittedBitrate: 0,
        transmittedFrameRate: 0
      },
      h264CodecProfile: 'BP',
      // TODO: parse the profile level from h264 in the SDP and save globally
      localConfigurationChanges: 0,
      // unavailable
      remoteConfigurationChanges: 0,
      // unavailable
      requestedFrameSize: 0,
      // unavailable
      requestedKeyFrames: 0,
      // unavailable
      transmittedFrameSize: 0,
      // unavailable
      transmittedHeight: 0,
      transmittedKeyFrames: 0,
      transmittedWidth: 0
    }]
  },
  intervalMetadata: {
    memoryUsage: {
      cpuBitWidth: 0,
      mainProcessMaximumMemoryBytes: 0,
      osBitWidth: 0,
      processAverageMemoryUsage: 0,
      processMaximumMemoryBytes: 0,
      processMaximumMemoryUsage: 0,
      systemAverageMemoryUsage: 0,
      systemMaximumMemoryUsage: 0
    },
    peerReflexiveIP: 'NULL',
    // TODO: save after ice trickling completes and use as a global variable
    processAverageCPU: 0,
    processMaximumCPU: 0,
    systemAverageCPU: 0,
    systemMaximumCPU: 0
  }
}; // ****** MEDIA QUALITY CONSTANTS ****** //

exports.MQA_STATS = MQA_STATS;
var QUALITY_LEVELS = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
};
exports.QUALITY_LEVELS = QUALITY_LEVELS;
var VIDEO_RESOLUTIONS = (_VIDEO_RESOLUTIONS = {}, (0, _defineProperty2.default)(_VIDEO_RESOLUTIONS, QUALITY_LEVELS.LOW, {
  video: {
    width: {
      max: 320,
      ideal: 320
    },
    height: {
      max: 180,
      ideal: 180
    }
  }
}), (0, _defineProperty2.default)(_VIDEO_RESOLUTIONS, QUALITY_LEVELS.MEDIUM, {
  video: {
    width: {
      max: 640,
      ideal: 640
    },
    height: {
      max: 360,
      ideal: 360
    }
  }
}), (0, _defineProperty2.default)(_VIDEO_RESOLUTIONS, QUALITY_LEVELS.HIGH, {
  video: {
    width: {
      max: 1280,
      ideal: 1280
    },
    height: {
      max: 720,
      ideal: 720
    }
  }
}), _VIDEO_RESOLUTIONS);
/**
 * Max frame sizes based on h264 configs
 * https://en.wikipedia.org/wiki/Advanced_Video_Coding
 */

exports.VIDEO_RESOLUTIONS = VIDEO_RESOLUTIONS;
var MAX_FRAMESIZES = (_MAX_FRAMESIZES = {}, (0, _defineProperty2.default)(_MAX_FRAMESIZES, QUALITY_LEVELS.LOW, 1620), (0, _defineProperty2.default)(_MAX_FRAMESIZES, QUALITY_LEVELS.MEDIUM, 3600), (0, _defineProperty2.default)(_MAX_FRAMESIZES, QUALITY_LEVELS.HIGH, 8192), _MAX_FRAMESIZES);
/*
*  mqa Interval for sending stats metrics
*/

exports.MAX_FRAMESIZES = MAX_FRAMESIZES;
var MQA_INTEVAL = 60000; // mqa analyzer interval its fixed to 60000

exports.MQA_INTEVAL = MQA_INTEVAL;
var MEDIA_DEVICES = {
  MICROPHONE: 'microphone',
  SPEAKER: 'speaker',
  CAMERA: 'camera'
};
exports.MEDIA_DEVICES = MEDIA_DEVICES;
var METRICS_JOIN_TIMES_MAX_DURATION = 1200000;
exports.METRICS_JOIN_TIMES_MAX_DURATION = METRICS_JOIN_TIMES_MAX_DURATION;
var PSTN_STATUS = {
  JOINED: 'JOINED',
  // we have provisioned a pstn device, which can be used to connect
  CONNECTED: 'CONNECTED',
  // user is connected to audio with pstn device
  LEFT: 'LEFT',
  // user has disconnected from the pstn device
  TRANSFERRING: 'TRANSFERRING',
  // usually happens in dial-out after the CONNECTED state
  SUCCESS: 'SUCCESS',
  // happens after the transfer (TRANSFERRING) is successful
  UNKNOWN: '' // placeholder if we haven't been told what the status is

};
exports.PSTN_STATUS = PSTN_STATUS;
var PASSWORD_STATUS = {
  NOT_REQUIRED: 'NOT_REQUIRED',
  // password is not required to join the meeting
  REQUIRED: 'REQUIRED',
  // client needs to provide the password by calling verifyPassword() before calling join()
  UNKNOWN: 'UNKNOWN',
  // we are waiting for information from the backend if password is required or not
  VERIFIED: 'VERIFIED' // client has already provided the password and it has been verified, client can proceed to call join()

};
exports.PASSWORD_STATUS = PASSWORD_STATUS;
var MEETING_INFO_FAILURE_REASON = {
  NONE: 'NONE',
  // meeting info was retrieved succesfully
  WRONG_PASSWORD: 'WRONG_PASSWORD',
  // meeting requires password and no password or wrong one was provided
  WRONG_CAPTCHA: 'WRONG_CAPTCHA',
  // wbxappapi requires a captcha code or a wrong captcha code was provided
  OTHER: 'OTHER' // any other error (network, etc)

};
exports.MEETING_INFO_FAILURE_REASON = MEETING_INFO_FAILURE_REASON;
//# sourceMappingURL=constants.js.map
